import React, { useState } from "react";
import { showRequestModal } from "../../../actions";
import { useDispatch } from "react-redux";
import config from '../../../config';
import { Spin } from 'antd';
import moment from 'moment';
import ClockIcon from "../../../images/clock.svg";

const CallbackItem = ({ callback, onCallNow, callingId }) => {
    console.log(callingId);
    const dispatch = useDispatch();
    const isCalling = callingId === callback.callbackRequestId;

    const {
        scheduledAt,
        tatMinutes,
        requestedBy,
        status,
        requestedAt
    } = callback;

    const displayTime = moment(scheduledAt).format('DD MMM, hh:mm A');




    // difference in minutes
    const scheduledMoment = moment(scheduledAt, 'YYYY-MM-DD HH:mm:ss');
    const now = moment();

    // difference in minutes
    const diffMinutes = scheduledMoment.diff(now, 'minutes');
    const isExceeded = diffMinutes < 0;

    const absMinutes = Math.abs(diffMinutes);
    const hours = Math.floor(absMinutes / 60);
    const minutes = absMinutes % 60;

    const formattedTat =
        hours > 0
            ? `${hours}h ${minutes}m`
            : `${minutes}m`;

    const canCallNow = diffMinutes <= 15;
    const callAtTime = moment(scheduledAt).format('hh:mm A');

    return (
        <div
            style={{
                padding: '12px',
                borderRadius: '10px',
                background: '#F8F7FF',
                marginBottom: '10px',
            }}
        >
            {/* Time + Status */}
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                <span style={{ color: isExceeded ? '#FF4D4D' : '#333', fontWeight: 600 }}>
                    {displayTime}
                </span>

                <div
                    onClick={() => !isCalling && canCallNow && onCallNow(callback)}
                    style={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: '8px',
                        color: isCalling ? '#AAA' : '#FF4D4D',
                        cursor: isCalling ? 'not-allowed' : 'pointer',
                        fontWeight: 700,
                        opacity: canCallNow ? 1 : 0.5,
                    }}
                >
                    {isExceeded && (
                        <span
                            style={{
                                fontSize: '12px',
                                fontWeight: 900,
                                marginRight: '10px',
                                color: '#B45309',

                                backgroundColor: '#FEF3C7', // light yellow
                                border: '1px solid #FCD34D', // yellow border
                                padding: '2px 8px',
                                borderRadius: '6px',
                                display: 'inline-flex',
                                alignItems: 'center',
                                gap: '4px',
                                lineHeight: 1.4,
                            }}
                        >
                            <img
                                src={ClockIcon}
                                alt="Clock"
                                style={{ width: '12px', height: '12px' }}
                            />
                            Time Exceeded
                        </span>
                    )}


                    {isCalling ? (
                        <Spin size="small" />
                    ) : canCallNow ? (
                        <span style={{ color: '#714FFF' }}>📞 Call Now</span>
                    ) : (
                        <span style={{ color: '#714FFF' }}>📞 Call at {callAtTime}</span>
                    )}
                </div>

            </div>


            {/* Message */}
            <div
                style={{
                    marginTop: '8px',
                    fontWeight: 600,
                    padding: isExceeded ? '8px 10px' : '0',
                    borderRadius: '6px',
                    background: isExceeded ? '#FFF3F3' : 'transparent',
                    borderLeft: isExceeded ? '4px solid #FF4D4D' : 'none',
                    color: isExceeded ? '#D32F2F' : '#000',
                }}
            >
                {isExceeded
                    ? 'Immediate action required on this request'
                    : `User requested for a callback after ${formattedTat}`}
            </div>

            {/* Requested by */}
            <div style={{ marginTop: '6px', fontSize: '12px', color: '#666' }}>
                Requested By:{' '}
                <b>{requestedBy}</b>{' '}
                <span
                    style={{
                        color: '#714FFF',
                        cursor: 'pointer',
                        fontWeight: 600,
                    }}
                    title="Request ID"
                    onClick={() => {
                        window.open(`${config.opsDashboardURL}revamp-offline-consults/${callback.requestId}`, "_blank");
                        const requestDetails = { /* Fetch or pass details as needed */ };
                        dispatch(showRequestModal(callback.requestId, requestDetails));
                    }}
                >
                    {callback.requestId}
                </span>
            </div>

            {/* Requested at */}
            <div style={{ marginTop: '6px', fontSize: '12px', color: '#666' }}>
                Requested At:{' '}
                <b>{requestedAt}</b>{' '}
                
            </div>

        </div>
    );
};

export default CallbackItem;
